import React from 'react'
import { useTranslation } from '../../hooks/useTranslation'
import { NavigationItem } from '../../types/navigation'

interface DropdownMenuProps {
  items?: NavigationItem[]
  parentId?: string
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({ items = [], parentId }) => {
  const { t, isRTL } = useTranslation()

  return (
    <div 
      className={`absolute top-full mt-2 w-64 bg-surface-2 border border-border rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 ${
        isRTL ? 'right-0' : 'left-0'
      }`}
    >
      <div className="py-2">
        {items.map((item) => (
          <a
            key={item.id}
            href={item.url}
            className="block px-4 py-2.5 text-sm text-text-2 hover:text-cyan hover:bg-surface-soft transition-colors duration-150"
          >
            {parentId ? t(`navbar.dropdowns.${parentId}.${item.id}`) : item.name}
          </a>
        ))}
      </div>
    </div>
  )
}

export default DropdownMenu